export const locales = ['ko', 'en', 'ja', 'zh'] as const
export type Locale = typeof locales[number]
export const languageNames: Record<Locale, string> = { ko: '한국어', en: 'English', ja: '日本語', zh: '简体中文' }
// HTML lang / hreflang target the language without narrowing it to a country.
export const htmlLanguages = { ko: 'ko', en: 'en', ja: 'ja', zh: 'zh-Hans' } as const
export const jsonLdLanguages = { ko: 'ko-KR', en: 'en-US', ja: 'ja-JP', zh: 'zh-Hans' } as const
export function isLocale(value: string): value is Locale { return locales.includes(value as Locale) }
export function splitLocale(path: string): { locale: Locale; path: string } {
  const match = path.match(/^\/(ko|en|ja|zh)(?=\/|$)/)
  return match ? { locale: match[1] as Locale, path: path.slice(match[0].length) || '/' } : { locale: 'ko', path }
}
export function localizedHref(href: string, locale: Locale): string {
  if (!href.startsWith('/') || href.startsWith('//') || /^\/(api|_next|og|figma|fonts)(\/|$)/.test(href) || /\.[a-z0-9]+(?:[?#]|$)/i.test(href)) return href
  const path = splitLocale(href).path
  // 슈링크와 리쥬란 근거 후기는 한국어 원문 경로를 유지한다.
  if (/^\/shurink(?:\/|[?#]|$)/.test(path) || /^\/rejuran\/[^/]+\/evidence(?:[/?#]|$)/.test(path)) return path
  if (/^\/ulthera\/(?:v1\/)?side-effect(?:\/|[?#]|$)/.test(path)) return path
  return locale === 'ko' ? path : `/${locale}${path === '/' ? '' : path}`
}
